import type { Currency } from '@ps/web-core-enums';
import type { ClubRecentTournamentSummary } from '@ps/web-shared-api-types/v0/SwHomeGames';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useIntl } from 'react-intl';

import { FormattedCurrencyAmount, stripHTML } from '@swf/poker';

import styles from './ResultsHeader.scss';
import { TXTCLI_Players, TXTCLI_Prize_Pool } from './Summary.messages.json';

const Summary: React.FC<ClubRecentTournamentSummary> = ({
  tournName,
  tournId,
  started,
  prizePool,
  numPlayers,
  currency,
  scalePM,
  playMoney
}) => (
  <div className={styles.summary}>
    <div>
      <div className={styles.name}>{stripHTML(tournName) || tournId}</div>
      <div className={styles.date}>
        {useIntl().formatDate(started?.split('T')[0], {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          weekday: 'long'
        })}
      </div>
    </div>
    <div className={styles.meta}>
      <div className={styles.metaItem}>
        <span>
          <Translation {...TXTCLI_Prize_Pool} />:
        </span>
        <FormattedCurrencyAmount
          amount={prizePool}
          scalePM={scalePM}
          isPlayMoney={playMoney}
          currency={currency as Currency}
        />
      </div>
      <div className={styles.metaItem}>
        <span>
          <Translation {...TXTCLI_Players} />:
        </span>
        {numPlayers}
      </div>
    </div>
  </div>
);

export default Summary;
